import { render, staticRenderFns } from "./Recuperar.vue?vue&type=template&id=5085d3b2&lang=pug"
import script from "./Recuperar.vue?vue&type=script&lang=js"
export * from "./Recuperar.vue?vue&type=script&lang=js"
import style0 from "./Recuperar.vue?vue&type=style&index=0&id=5085d3b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports